import { useCallback, useRef } from "react";

// Custom hook để quản lý tập trung các ref trong một màn hình
const useRefsManager = () => {
  // Khởi tạo một đối tượng chứa các ref để gắn vào các phần tử HTML
  const refContainer = useRef<{ [key: string]: HTMLInputElement | null }>({});

  // Hàm này dùng để gắn phần tử HTML vào đối tượng refsContainer
  const attachRef = useCallback(
    (name: string) => (el: HTMLInputElement | null) => {
      refContainer.current[name] = el;
    },
    []
  ); // dùng useCallBack cho trường hợp gắn vào các component bị rerender lại liên tọi

  return { attachRef, elementsRef: refContainer.current };
};

export default useRefsManager;
